export default function Privacy() {
  return (
    <section className="grain relative bg-black px-6 pb-32 pt-40">
      <div className="container-x max-w-3xl">
        <p className="label mb-6 inline-flex items-center gap-3">
          <span className="h-px w-10 bg-gold" />
          Privacy
        </p>
        <h1 className="font-display text-section font-light text-white">
          Privacy Notice
        </h1>
        <p className="mt-4 font-sans text-caption text-stone">
          Samia Systems Limited · United Kingdom
        </p>

        <div className="prose prose-invert mt-12 flex flex-col gap-6 font-sans text-body text-white/85">
          <p>
            Samia Systems Limited ("we", "us") is the data controller for any
            personal data you provide on this website. We collect only the
            information needed to respond to your enquiry, deliver the
            documents you request, and operate this site.
          </p>

          <h2 className="font-display text-2xl font-light text-white">
            What we collect
          </h2>
          <p>
            When you complete the consultation form, we collect your name,
            email, area of interest, project budget, monthly revenue, notes,
            and any guest email addresses you provide. We use these details to
            assess the appropriate next step, prepare for qualified meetings,
            and maintain our enquiry records in Notion. Qualified visitors who
            book are also processed by Cal.com under its privacy terms.
          </p>
          <p>
            When you download from the Library, we collect the name, email,
            phone number, and project type you submit, alongside the timestamp,
            IP address, and user-agent of your request, in order to send you
            the document and follow up on your enquiry.
          </p>

          <h2 className="font-display text-2xl font-light text-white">
            How we use it
          </h2>
          <p>
            We use the information you provide to fulfil your request, to
            follow up where appropriate, and to keep records consistent with UK
            GDPR. We do not sell your data and we do not pass it to third
            parties beyond the processors required to operate this site
            (Cloudflare, Resend, Notion and Cal.com).
          </p>

          <h2 className="font-display text-2xl font-light text-white">
            Your rights
          </h2>
          <p>
            You may request access to, correction of, or deletion of your
            personal data at any time. Email{' '}
            <a href="mailto:info@samiasystems.com" className="text-gold">
              info@samiasystems.com
            </a>{' '}
            and we will respond within thirty days.
          </p>
        </div>
      </div>
    </section>
  );
}
